export default __webpack_public_path__ + "static/media/laravel_cms.c9bbf4f7.png";